module.exports = __webpack_public_path__ + "static/media/dsr_ico_grow.94ab0a30.svg";